import styled from '@emotion/styled';
import WhatsAppTemplateList from './WhatsAppTemplateList';

interface DisabledMaskProps {
  conversation: Conversation.Conversation;
  disableText?: React.ReactNode;
  onSend?: () => void;
}

export const DisabledMask = (props: DisabledMaskProps) => {
  const { conversation, disableText, onSend } = props;
  const { channel, waConvInfo } = conversation;

  if (channel === 'WA_BIZ' && !waConvInfo?.existUserMsg) {
    return (
      <EditorCover>
        <WhatsAppTemplateList conversation={conversation} onSend={onSend} />
      </EditorCover>
    );
  }

  if (!!disableText) {
    return (
      <EditorCover>
        <div>{disableText}</div>
      </EditorCover>
    );
  }

  return null;
};

const EditorCover = styled.div`
  cursor: not-allowed;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: var(--fett-bg-mask);
  display: flex;
  justify-content: center;
  align-items: center;
  > div {
    color: var(--fett-text-tertiary);
    font-size: 14px;
    text-align: center;
    white-space: break-spaces;
  }
`;
